import React, {
  ReactElement,
  useRef,
  MutableRefObject,
  useEffect
} from "react";
import { motion } from "framer-motion";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { addNode, updateNode } from "slices/stage-nodes";
import { NodeParams } from "models/system";
import { updateShowParams } from "slices/system";
import { Node } from "models/system";
import { RootState } from "redux-setup/root-reducer";
import { SystemStates } from "constants/system-states";

interface Props {
  strokeColor?: string;
  xPosition: string;
  yPosition: string;
  animate: any;
  key: string;
  node: any;
  id: string;
}
export default function TSB(props: Props): ReactElement {
  const dispatch = useDispatch();
  let system = useSelector((state: RootState) => {
    let obj = {
      state: state.system.system.state,
      health: state.system.system.health,
      hint: state.system.system.hint,
      params: state.system.params
    };
    return obj;
  }, shallowEqual);

  const tsbRef = useRef() as MutableRefObject<SVGRectElement>;

  let nodeItem: Node = {
    nodeId: props.id,
    xPosition: 0,
    yPosition: 0,
    height: 0,
    width: 0,
    isAnimating: true
  };

  dispatch(addNode(nodeItem));

  useEffect(() => {
    if (
      system.state === SystemStates.ADD_TSB &&
      system.health > 95 &&
      system.health <= 96
    ) {
      showParams(props.id);
      setTimeout(() => {
        hideParams(props.id);
      }, 4000);
    }
  }, [system.health]);

  function onAnimationComplete() {
    if (tsbRef !== null && tsbRef.current !== null) {
      let obj = tsbRef.current.getBBox();

      let nodeItem: Node = {
        nodeId: props.id,
        xPosition: obj.x,
        yPosition: obj.y,
        height: obj.height,
        width: obj.width,
        isAnimating: false
      };

      dispatch(updateNode(nodeItem));
    }
  }

  function showParams(id: string) {
    if (system.params.nodeId !== id && system.params.showParams === false) {
      let node: NodeParams = {
        nodeId: id,
        showParams: true
      };
      dispatch(updateShowParams(node));
    }
  }

  function hideParams(id: string) {
    let node: NodeParams = {
      nodeId: "",
      showParams: false
    };
    dispatch(updateShowParams(node));
  }

  return (
    <motion.g ref={tsbRef}>
      <motion.svg
        version="1.1"
        viewBox="0 0 421 267"
        overflow="visible"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        height={props.node.height}
        width={props.node.width}
        x={props.xPosition}
        y={props.yPosition}
        onClick={() => showParams(props.id)}
      >
        <motion.defs></motion.defs>

        <motion.g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          variants={props.animate.tsb}
          initial="hidden"
          animate="visible"
          transition={{
            default: { duration: 0.5, delay: 0, ease: "easeInOut" }
          }}
          onAnimationComplete={onAnimationComplete}
        >
          <motion.g
            id="16"
            transform="translate(-188.000000, -79.000000)"
            initial={
              props.node.setOpacity != undefined &&
              props.node.setOpacity === false
                ? { opacity: 1 }
                : { opacity: 0 }
            }
            animate={{ opacity: 1 }}
            transition={{
              default: {
                duration: 0.5,
                delay: (props.node.animationDelay ?? 5) + 0.5
              }
            }}
          >
            <motion.g
              id="TSB-Applied"
              transform="translate(0.000000, 60.000000)"
            >
              <motion.g
                id="Group-5"
                transform="translate(189.000000, 20.000000)"
              >
                <motion.path
                  d="M2,0 L398,0 C399.104569,-2.02906125e-16 400,0.8954305 400,2 L400,263 C400,264.104569 399.104569,265 398,265 L2,265 C0.8954305,265 1.3527075e-16,264.104569 0,263 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
                  id="Rectangle-Copy-32"
                  variants={props.animate.rectangle}
                  initial="hidden"
                  animate="visible"
                  transition={{
                    default: {
                      duration: 0.5,
                      delay: props.node.animationDelay ?? 5
                    }
                  }}
                ></motion.path>
                <motion.g
                  id="TSB-Green"
                  transform="translate(380.000000, 112.000000)"
                  initial={
                    props.node.setOpacity != undefined &&
                    props.node.setOpacity === false
                      ? { opacity: 1 }
                      : { opacity: 0 }
                  }
                  animate={{ opacity: 1 }}
                  transition={{
                    default: {
                      duration: 0.5,
                      delay: (props.node.animationDelay ?? 5) + 0.5
                    }
                  }}
                >
                  <motion.g id="TSB">
                    <motion.g id="Istio-Copy">
                      <motion.g id="Group-4">
                        <motion.g id="Group-24">
                          <motion.g id="Oval-Copy-3">
                            <motion.use
                              fill="black"
                              fill-opacity="1"
                              filter="url(#filter-3)"
                              xlinkHref="#path-2"
                            ></motion.use>
                            <motion.use
                              stroke="#3A955E"
                              stroke-width="2"
                              fill="url(#radialGradient-1)"
                              fill-rule="evenodd"
                              xlinkHref="#path-2"
                            ></motion.use>
                          </motion.g>
                          <motion.g
                            id="tetrate-a"
                            transform="translate(12.000000, 10.000000)"
                          >
                            <motion.path
                              d="M2.10241446,4.80291978 C2.15191566,4.80291978 2.20691699,4.80841991 2.25641819,4.80841991 C4.68197686,4.87992164 6.4365193,3.57639011 7.71255017,1.29933502 C8.04805829,0.655819456 8.72457465,0.215808812 9.50009341,0.215808812 C10.2811123,0.215808812 10.9576287,0.655819456 11.2931368,1.30483516 C12.5691677,3.58189024 14.31821,4.87992164 16.7382685,4.80841991 C16.7932698,4.80841991 16.8482712,4.80291978 16.8977724,4.80291978 C18.0142994,4.80291978 18.9163212,5.7049416 18.9163212,6.82146861 C18.9163212,7.93799562 18.0142994,8.84001744 16.8977724,8.84001744 C16.0782525,8.84001744 15.3742355,8.35050559 15.0607279,7.6519887 C14.0377032,5.55093787 11.7936489,4.28590727 9.51109368,4.24740634 L9.50009341,4.24740634 L9.48909315,4.24740634 C7.20653793,4.28590727 4.96248365,5.55093787 3.9394589,7.6519887 C3.62595132,8.35050559 2.92193428,8.84001744 2.10241446,8.84001744 C0.985887451,8.84001744 0.0838656305,7.93799562 0.0838656305,6.82146861 C0.0838656305,5.7049416 0.985887451,4.80291978 2.10241446,4.80291978 Z M10.9906295,18.7182564 C11.0346305,18.7677576 11.0786316,18.8227589 11.1171325,18.8722601 L11.1171325,18.8722601 L11.1171325,18.8722601 C11.3481381,19.196768 11.4801413,19.5927776 11.4801413,20.0162878 C11.4801413,21.1108143 10.5946199,22.0018358 9.50009341,22.0018358 C8.40556694,22.0018358 7.52004552,21.1108143 7.52004552,20.0162878 C7.52004552,19.5927776 7.65204871,19.196768 7.8830543,18.8722601 L7.8830543,18.8722601 L7.8830543,18.8722601 C7.92155523,18.8172588 7.96555629,18.7677576 8.00405722,18.7182564 C9.03808224,17.3047222 9.12058423,14.1641462 7.22303833,11.7275873 L7.22303833,11.7275873 C6.82152862,11.2270752 6.57952276,10.5890597 6.57952276,9.89604298 C6.57952276,8.284504 7.88855443,6.97547233 9.50009341,6.97547233 C11.1116324,6.97547233 12.4206641,8.284504 12.4206641,9.89604298 C12.4206641,10.5890597 12.1786582,11.2270752 11.7716484,11.7275873 L11.7771485,11.7275873 C9.87960259,14.1641462 9.96210459,17.3047222 10.9906295,18.7182564 Z M9.50009341,8.01499748 C10.5891198,8.01499748 11.469141,8.89501877 11.469141,9.98404511 C11.469141,11.0730715 10.5891198,11.9585929 9.50009341,11.9585929 C8.41106707,11.9585929 7.53104578,11.0730715 7.53104578,9.98404511 C7.53104578,8.89501877 8.41106707,8.01499748 9.50009341,8.01499748 Z"
                              id="Shape"
                              fill="#FFFFFF"
                            ></motion.path>
                            <motion.circle
                              id="Oval"
                              fill="#FF5A0D"
                              cx="9.50009341"
                              cy="9.98404511"
                              r="1.71054138"
                            ></motion.circle>
                          </motion.g>
                        </motion.g>
                      </motion.g>
                    </motion.g>
                  </motion.g>
                </motion.g>
              </motion.g>
            </motion.g>
          </motion.g>
        </motion.g>
      </motion.svg>
    </motion.g>
  );
}
